<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-column">
            <b-table class="mt-3 py-5" striped :items="arquivosPrimeseg" :fields="fields" show-empty :busy="carregando" responsive>
                <template #empty>
                    <div class="d-flex">
                        <span class="mx-auto">
                            Nenhum Arquivo Encontrado
                        </span>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(nome)="data">{{ data.item.nome + data.item.extensao }}</template>
                <template #cell(dataInicio)="data">{{  $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY HH:mm") }}</template>
                <template #cell(acao)="data">
					<b-dropdown variant="secondary" text="Selecione" boundary="window">
                        <b-dropdown-item @click="baixarArquivo(data.item.id)">
                            <font-awesome-icon icon="fa-solid fa-download" />
                            Baixar
                        </b-dropdown-item>
						<b-dropdown-item @click="abrirModalVisualizarDescricao(data.item.id)">
                            <font-awesome-icon icon="fa-solid fa-file" />
                            Visualizar Descrição
                        </b-dropdown-item>
                        <b-dropdown-item @click="abrirModalAtualizarDescricaoArquivo(data.item)">
                            <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                            Editar Descrição
                        </b-dropdown-item>
                        <b-dropdown-item @click="abrirModalExcluirArquivo(data.item)">
                            <font-awesome-icon icon="fa-solid fa-trash" />
                            Excluir
                        </b-dropdown-item>
                    </b-dropdown>
					<modal-visualizar-descricao-arquivo :arquivo="data.item"/>
                </template>
            </b-table>
			<modal-atualizar-descricao-arquivo-primeseg ref="modalAtualizarDescricaoArquivo" @input="filtrarArquivosPorUsuario()"/>
			<modal-excluir-arquivo-primeseg ref="modalExcluirArquivo" @input="filtrarArquivosPorUsuario()"/>
            <div class="my-2 d-flex flex-column" v-if="!carregando">
                <span>Número de arquivos: {{ numeroDeLinhasTabelaArquivosPrimeseg }}</span>
            </div>
            <b-pagination @input="consultarArquivosPorUsuario" class="mx-auto" v-model="paginaAtualTabelaArquivosPrimeseg" :total-rows="numeroDeLinhasTabelaArquivosPrimeseg" :per-page="arquivosPrimesegPorPagina" ></b-pagination>
        </div>
    </div>
</template>

<script>
import ArquivoPrimesegService from "../../service/ArquivoPrimesegService.js";
import ModalVisualizarDescricaoArquivo from "../Arquivos/ModalVisualizarDescricaoArquivo.vue";
import ModalAtualizarDescricaoArquivoPrimeseg from "./ModalAtualizarDescricaoArquivoPrimeseg.vue";
import ModalExcluirArquivoPrimeseg from "./ModalExcluirArquivoPrimeseg.vue";

export default {
	components: { ModalVisualizarDescricaoArquivo, ModalAtualizarDescricaoArquivoPrimeseg, ModalExcluirArquivoPrimeseg },
	name: "TableArquivosPrimeseg",
	props: [ "usuario" ],
	data() {
		return {
			paginaAtualTabelaArquivosPrimeseg: 1,
			numeroDeLinhasTabelaArquivosPrimeseg: 0,
			arquivosPrimesegPorPagina: 15,

			fields: [
				{ label: "#", key: "index" },
				{ label: "Nome", key: "nome" },
				{ label: "Data/Hora De Envio", key: "dataInicio" },
				{ label: "", key: "acao" },
			],
			arquivosPrimeseg: [],
			carregando: false,
			exibirSalvarArquivoUsuario: false,
		};
	},
	created() {
		this.consultarArquivosPorUsuario();
	},
	methods: {
		abrirModalVisualizarDescricao(id) {
			this.$bvModal.show("modal-visualizar-descricao-arquivo-" + id);
		},
		abrirModalAtualizarDescricaoArquivo(arquivo) {
			this.$refs.modalAtualizarDescricaoArquivo.abrirModal(arquivo);
		},
		abrirModalExcluirArquivo(arquivo) {
			this.$refs.modalExcluirArquivo.abrirModal(arquivo);
		},
		baixarArquivo(id) {
			this.carregando = true;
			ArquivoPrimesegService.baixar(id).then((res) => {
				this.$fileUtils.baixarArquivo(res.data.arquivo, res.data.nome);
				this.mensagem("Download do arquivo realizado com sucesso !", "Sucesso", "success");
			}).catch((err) => {
				console.log(err);
				if (err.response) {
					this.mensagem(err.response.data, "Erro", "danger");
				} else {
					this.mensagem("Não foi possível realizar o download do arquivo nesse momento", "Erro", "danger");
				}
			}).finally(() => {
				this.carregando = false;
			});
		},
		filtrarArquivosPorUsuario() {
			this.paginaAtualTabelaArquivosPrimeseg = 1;
			this.consultarArquivosPorUsuario();
		},
		consultarArquivosPorUsuario() {
			this.carregando = true;
			ArquivoPrimesegService.consultarArquivosPorUsuario(this.usuario.id, this.paginaAtualTabelaArquivosPrimeseg - 1, this.arquivosPrimesegPorPagina).then((res) => {
				this.arquivosPrimeseg = res.data[0];
				this.numeroDeLinhasTabelaArquivosPrimeseg = res.data[1];
			}).catch(() => {
				this.mensagem("Não foi possível consultar os arquivos do usuário nesse momento", "Erro", "danger");
			}).finally(() => {
				this.carregando = false;
			});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosPrimeseg/TableArquivosPrimeseg.vue